import React from "react";
import "./botonWhatsappFlotante.css";

const WHATSAPP =
  "https://wa.me/5492396416909?text=Hola%2C%20quer%C3%ADa%20obtener%20informaci%C3%B3n%20acerca%20de%20Mundo%20Piloto";

// Botón flotante de WhatsApp, fijo abajo a la derecha (lo usan /promocion y el home)
export const BotonWhatsappFlotante = () => (
  <a
    href={WHATSAPP}
    className="whatsapp-flotante"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Escribinos por WhatsApp"
  >
    <img src="/img/promo/whatsapp-icon.svg" alt="WhatsApp" />
  </a>
);
